import { create } from 'zustand';
import type { Me } from '../../../shared/types';
import { api, ApiError } from '../api/client';

interface SessionState {
  me: Me | null;
  status: 'idle' | 'loading' | 'ready' | 'denied' | 'error';
  error: string | null;
  load: () => Promise<void>;
  reset: () => void;
}

export const useSession = create<SessionState>((set) => ({
  me: null, status: 'idle', error: null,
  load: async () => {
    set({ status: 'loading', error: null });
    try {
      const me = await api<Me>('/api/me');
      set({ me, status: 'ready' });
    } catch (err) {
      const e = err as ApiError;
      set({ me: null, status: e.status === 403 ? 'denied' : 'error', error: e.message });
    }
  },
  reset: () => set({ me: null, status: 'idle', error: null }),
}));
